<template>
  <basic-dialog
    :show="show"
    @close="$emit('close')"
    max-width="500px"
    draggable
  >
    <template v-slot:title>Move Itinerary</template>
    <v-row>
      <v-col class="py-0">
        <v-date-picker v-model="startDate" full-width></v-date-picker>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12"
        ><v-row justify="center">
          <v-btn @click="onSetNewStartDate"
            ><v-icon left>mdi-calendar</v-icon>Set New Start Date as:
            <strong>{{ startDate | formatDate }}</strong></v-btn
          >
        </v-row>
      </v-col></v-row
    >
    <v-row>
      <v-col>
        <v-divider></v-divider>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-select
          :items="directionItems"
          v-model="direction"
          label="Direction"
          item-text="name"
          item-value="value"
          :outlined="outlinedInputs"
          hide-details
        ></v-select>
      </v-col>
      <v-col>
        <v-text-field
          label="Days"
          type="number"
          v-model.number="days"
          :outlined="outlinedInputs"
          min="1"
          hide-details
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12"
        ><v-row justify="center">
          <v-btn @click="onMoveByDays"
            ><v-icon left>mdi-calendar-blank</v-icon>Move {{ direction }}
            {{ days }} {{ days == 1 ? "day" : "days" }}</v-btn
          >
        </v-row>
      </v-col></v-row
    >
    <v-row>
      <v-col>
        <v-divider></v-divider>
      </v-col>
    </v-row>
    <v-alert dense outlined text type="error"
      >If rates don't exist for the new dates, the system will automatically use
      the current rates and identify them as custom prices</v-alert
    >
    <div v-if="debug">
      <code>{{ startDate }}</code>
    </div>
  </basic-dialog>
</template>

<script>
import BasicDialog from "../../../shared/BasicDialog";
export default {
  name: "MoveItinerary",

  props: {
    show: {
      type: Boolean,
      default: () => false,
    },
    date: {
      type: String,
      default: () => "",
    },
  },

  components: { BasicDialog },

  data() {
    return {
      debug: false,
      startDate:
        this.date != "" ? this.date : new Date().toISOString().substr(0, 10),
      direction: "forward",
      directionItems: [
        { name: "Forward", value: "forward" },
        { name: "Backward", value: "backward" },
      ],
      days: 1,
    };
  },

  computed: {
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
  },

  watch: {
    date(newDate) {
      this.startDate = newDate;
    },
  },

  methods: {
    onSetNewStartDate() {
      this.$emit("newStartDate", this.startDate);
    },
    onMoveByDays() {
      this.$emit("move", { direction: this.direction, noOfDays: this.days });
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/itineraries/builder/tools/MoveItinerary.vue